import React from 'react';
import classNames from 'classnames';

import './LoadingIndicatorProgress.css';

/**
 *  A React component that renders a loading indicator.
 * if progress is not provided, it will render an infinite loading indicator
 * if progress is provided, it will render a progress bar
 * Optionally a textBlock can be provided to display a message
 */
function LoadingIndicatorProgress({ className, textBlock, progress, indicatorStyle }) {
  return (
    <div
      className={classNames(
        'z-50 top-0 left-0 flex flex-col items-center justify-center space-y-5',
        className
      )}
    >
      <div className="loading"
           style={indicatorStyle}>
        {progress === undefined || progress === null ? (
          <div className="infinite-loading-bar bg-primary-light"></div>
        ) : (
          <div
            className="bg-primary-light"
            style={{
              width: `${progress}%`,
              height: '8px',
            }}
          ></div>
        )}
      </div>
        {textBlock}
    </div>
  );
}

export default LoadingIndicatorProgress;
